import {
	trigger,
	state,
	animate,
	transition,
	style
} from '@angular/animations';

export const slideInOutAnimation = trigger('slideInOutAnimation', [
	// end state styles for route container (host)
	state(
		'*',
		style({
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			padding: '85px 15px 0 15px',
			height: '100%',
			overflow: 'auto'
			// backgroundColor: 'rgba(0, 0, 0, 0.8)'
		})
	),

	// route 'enter' transition
	transition(':enter', [
		// styles at start of transition
		style({
			// start with the content positioned off the right of the screen,
			// -400% is required instead of -100% because the negative position adds to the width of the element
			right: '-400%',

			// start with background opacity set to 0 (invisible)
			// backgroundColor: 'rgba(0, 0, 0, 0)'
		}),

		animate(
			'.4s ease-in-out',
			style({
				right: 0,
				// backgroundColor: 'rgba(0, 0, 0, 0.8)'
			})
		)
	]),

	// route 'leave' transition
	// transition(':leave', [
	// 	animate(
	// 		'.4s ease-in-out',
	// 		style({
	// 			right: '-400%',
	// 			backgroundColor: 'rgba(0, 0, 0, 0)'
	// 		})
	// 	)
	// ])
]);
